import { useState, useCallback, useEffect } from 'react';

const getInitialState = (name) => {
  const STORAGE_KEY = `sn-elearning-bookmarks_${name || 'default'}`;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch { return []; }
};

export function useBookmarks(userName = '') {
  const [bookmarks, setBookmarks] = useState(() => getInitialState(userName));

  useEffect(() => {
    setBookmarks(getInitialState(userName));
  }, [userName]);

  useEffect(() => {
    const STORAGE_KEY = `sn-elearning-bookmarks_${userName || 'default'}`;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(bookmarks));
  }, [bookmarks, userName]);

  const toggleBookmark = useCallback((sectionId) => {
    setBookmarks(prev =>
      prev.includes(sectionId)
        ? prev.filter(id => id !== sectionId)
        : [...prev, sectionId]
    );
  }, []);

  const isBookmarked = useCallback((sectionId) => {
    return bookmarks.includes(sectionId);
  }, [bookmarks]);

  return { bookmarks, toggleBookmark, isBookmarked };
}
